"use strict";
/*
 * Created on 29.11.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromotionActionContext_1 = require("../model/PromotionActionContext");

var PromotionActionContextConverter_1 = require("./PromotionActionContextConverter");
/**
 * @author MSu
 */


var PromotionActionContextConverterImpl =
/*#__PURE__*/
function (_PromotionActionConte) {
  _inherits(PromotionActionContextConverterImpl, _PromotionActionConte);

  function PromotionActionContextConverterImpl() {
    _classCallCheck(this, PromotionActionContextConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionActionContextConverterImpl).apply(this, arguments));
  }

  _createClass(PromotionActionContextConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromotionActionContext_1.PromotionActionContext(PromotionActionContext_1.PromotionActionContext.schema.promotionId.valueOfField(source), PromotionActionContext_1.PromotionActionContext.schema.actionType.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        promotionId: source.promotionId,
        actionType: source.actionType
      };
    }
  }]);

  return PromotionActionContextConverterImpl;
}(PromotionActionContextConverter_1.PromotionActionContextConverter);

exports.PromotionActionContextConverterImpl = PromotionActionContextConverterImpl;